import { lazy } from 'react';

// project imports
import GuestGuard from 'utils/route-guard/GuestGuard';
import MinimalLayout from 'layout/MinimalLayout';
import NavMotion from 'layout/NavMotion';
import Loadable from 'ui-component/Loadable';
// import Login from 'views/pages/authentication/authentication/Login';

// login routing
const Login = Loadable(lazy(() => import('views/pages/authentication/authentication/Login')));
const Register = Loadable(lazy(() => import('views/pages/authentication/authentication/Register')));
const ForgotPassword = Loadable(lazy(() => import('views/pages/authentication/authentication/ForgotPassword')));
const AuthResetPassword = Loadable(lazy(() => import('views/pages/authentication/authentication/ResetPassword')))
// ==============================|| ROUTING available when NOT LOGGED IN ||============================== //


const LoginRoutes = {
    path: '/',
    element: (
        <NavMotion>
            <GuestGuard>
                <MinimalLayout />
            </GuestGuard>
        </NavMotion>
    ),
    children: [
        {
            path: '/login',
            element: <Login />
        },
        {
            path: '/register',
            element: <Register />
        },
        {
            path: '/reset-password',
            element: <AuthResetPassword />
        },
        {
            path: '/forgot',
            element: <ForgotPassword />
        },  
         
    ]
};

export default LoginRoutes;
